import BlogToSliderContainer from "../../../../components/pages/blog/blogPage/BlogToSlider";

const BlogToSlider = () => {
  return <BlogToSliderContainer />;
};

export default BlogToSlider;
